<div v-if="shouldRenderConfig" v-bind:class="getClassName">
    <!-- <div class="matrix_inputQuantityLabel">{{ $t(name) }}</div> -->
    <div class="matrix_inputQuantityInput">
        <input type="number" class="form-control" v-model="quantity" 
            v-on:keydown.enter="onQuantityEnter"
            :placeholder="$t(name)"
        />
        <button type="button" class="btn btn-primary" v-on:click="onQuantityEnter">+</button>
    </div>
    
</div>

